<div class="container-fluid mt-4">
  <div class="card">
    <div class="card-header">
      <h3 class="card-title">
        VR-Speech Trainer Accounts
        <span class="btn-wrapper">
          <button type="button" class="btn btn-success btn-sm me-1" (click)="reload()">
            <fa-icon [icon]="['fal','sync']"></fa-icon>
          </button>
        </span>
        <button type="button" class="btn btn-primary btn-sm" (click)="create()" [disabled]="!canEdit">
          <fa-icon [icon]="['fal', 'plus']"></fa-icon> Create
        </button>
      </h3>
      <fa-icon class="card-header-icon bg-gradient-primary text-white" icon="head-vr" size="lg" [fixedWidth]="true"> </fa-icon>
    </div>
    <div class="card-body">
      <div *ngIf="trainers" class="table-responsive">
        <table class="table table-hover">
          <thead class="text-primary">
            <tr>
              <th>Username</th>
              <th>Mail</th>
              <th>Managed Licences</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr class="table-row" *ngFor="let trainer of trainers">
              <td>{{ userLookup[trainer.uuid].username }}</td>
              <td>{{ userLookup[trainer.uuid].meta.mail }}</td>
              <td>
                <table class="table table-hover">
                  <thead class="text-primary">
                    <tr>
                      <th>Key</th>
                      <th>Activations</th>
                      <th>Roles</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    <ng-container *ngFor="let licence of trainer.licences">
                      <tr>
                        <ng-container *ngIf="!licenceLookup[licence]">
                          <td colspan="3">{{ licence }}</td>
                        </ng-container>
                        <ng-container *ngIf="licenceLookup[licence]">
                          <td>{{ licence }}</td>
                          <td *ngIf="licenceLookup[licence].volume > 0">
                            {{ licenceLookup[licence].activations }} / {{ licenceLookup[licence].volume }}
                          </td>
                          <td *ngIf="!(licenceLookup[licence].volume > 0)">{{ licenceLookup[licence].activations }}</td>
                          <td>
                            <ng-container *ngFor="let role of licenceLookup[licence].profile.meta.roles; let last = last">
                              <span>{{ role }}</span>
                              <span *ngIf="!last">, </span>
                            </ng-container>
                          </td>
                        </ng-container>
                        <td>
                          <button
                            type="button"
                            class="btn btn-danger btn-sm"
                            ngbTooltip="Remove managed licence"
                            placement="left"
                            container="body"
                            [disabled]="!canDelete"
                            (click)="removeLicence(trainer.uuid, licence)"
                          >
                            <fa-icon [icon]="['fal','times']" [fixedWidth]="true"></fa-icon>
                          </button>
                        </td>
                      </tr>
                    </ng-container>
                  </tbody>
                </table>
              </td>
              <td>
                <button
                  type="button"
                  class="btn btn-primary btn-sm me-1"
                  ngbTooltip="Add managed licence"
                  placement="left"
                  container="body"
                  [disabled]="!canEdit"
                  (click)="update(userLookup[trainer.uuid])"
                >
                  <fa-icon [icon]="['fal','plus']" [fixedWidth]="true"></fa-icon>
                </button>
                <button
                  type="button"
                  class="btn btn-danger btn-sm"
                  ngbTooltip="Remove all trainer privileges"
                  placement="left"
                  container="body"
                  [disabled]="!canDelete"
                  (click)="deleteTrainer(trainer.uuid)"
                >
                  <fa-icon [icon]="['fal','trash']" [fixedWidth]="true"></fa-icon>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
